import type { ThemeColor } from '@sites/site-theme/src/types';

import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { SpColorPickerPresetsComponent } from '../sp-color-picker-presets/sp-color-picker-presets.component';
import { SpColorPickerCustomColorComponent } from '../sp-color-picker-custom-color/sp-color-picker-custom-color.component';

@Component({
    selector: 'sp-color-picker-dropdown',
    templateUrl: './sp-color-picker-dropdown.component.html',
    styleUrls: ['./sp-color-picker-dropdown.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpColorPickerPresetsComponent, SpColorPickerCustomColorComponent],
})
export class SpColorPickerDropdownComponent {
    @Input() public color!: string;
    @Input() public colorsPreset: ThemeColor[];
    @Input() public hideGradient: boolean;

    @Output() public setColorEvent: EventEmitter<string> = new EventEmitter<string>();
    @Output() public setColorPresetEvent: EventEmitter<ThemeColor> = new EventEmitter<ThemeColor>();

    public showCustom = false;

    public setColorHandler(value: string): void {
        this.setColorEvent.emit(value);
    }

    public setColorPresetHandler(preset: ThemeColor): void {
        this.setColorPresetEvent.emit(preset);
    }
}
